import { BottomSheetIllustrationContent, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { Button } from "@src/appV2/redesign/components/Button";
import { DialogFooter } from "@src/appV2/redesign/components/DialogFooter";

export interface ActionSkippedContentProps {
  action: "clock-in" | "clock-out";
  onAccept: () => void;
  onCancel: () => void;
}

function getActionTexts(action: "clock-in" | "clock-out"): {
  description1: string;
} {
  switch (action) {
    case "clock-in": {
      return {
        description1: "Clock in with the workplace time-clock to get paid right after your shift.",
      };
    }

    case "clock-out": {
      return {
        description1: "Clock out with the workplace time-clock to get paid right after your shift.",
      };
    }

    default: {
      return action satisfies never;
    }
  }
}

export function ActionSkippedContent(props: ActionSkippedContentProps) {
  const { action, onAccept, onCancel } = props;
  const texts = getActionTexts(action);

  return (
    <>
      <BottomSheetIllustrationContent
        hasFooter
        illustrationType="non-instant-pay"
        title="Skip InstantPay?"
        description={
          <Stack gap={5}>
            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.secondary })}
            >
              {texts.description1}
            </Text>
            <Text
              semibold
              variant="body1"
              sx={(theme) => ({ color: theme.palette.text.secondary })}
            >
              If you skip, you&apos;ll need to wait up to 3 business days while the workplace
              reviews and approves your hours.
            </Text>
          </Stack>
        }
      />
      <DialogFooter
        orientation="vertical"
        closeButtonAriaLabel="Cancel"
        closeButtonIconType="arrow-left"
        onClose={() => {
          onCancel();
        }}
      >
        <Button
          fullWidth
          variant="destructive"
          size="large"
          onClick={() => {
            onAccept();
          }}
        >
          Accept 3-day delay
        </Button>
      </DialogFooter>
    </>
  );
}
